import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogComponent } from 'src/app/components/contact-dialog/contact-dialog.component';
import { StreApperInfo } from 'src/app/models/streapper-info.model';

@Component({
    selector: 'header-content',
    templateUrl: './header-content.component.html',
    styleUrl: './header-content.component.scss',
    standalone: false
})
export class HeaderContentComponent {
  @Input()
  profile: StreApperInfo;

  @Input()
  rank: number;

  public constructor(private readonly dialog: MatDialog) {}

  openContactDialog(): void {
    this.dialog.open<ContactDialogComponent>(ContactDialogComponent, {
      autoFocus: false, // To prevent select state of close button in header
    });
  }
}
